module.exports = __webpack_public_path__ + "img/cloud2.1107c157.png";